export default __webpack_public_path__ + "static/media/miguel-lopes-7.e16f0eb7.jpg";